import { gql } from '@apollo/client';

export const BASE_ASSET = gql`
  fragment BaseAsset on Asset {
    id
    name

    address
    externalId
    categoryId
    assetType
    creationType
    schemaId
    parentAssetId
    colorId
    markerId
    isMaterial
    mainPhotoFileId
    inactive
    ancestors {
      id
      name
    }

    changeType
    includeChangesBefore

    lastAppliedWorkOrderName
    lastAppliedDate
    lastWorkOrder {
      id
      name
      updatedDate
    }

    location {
      coordinates
      type
    }
    locationType

    attributeGroups {
      id
      name
      attributes {
        id
        name
        value
        newValue
        changeId
        defaultValue
        enumeration
        isEditable
        isRequired
        unit
        group
        order
        dataType
        thousandsSeparator
        isVisibleAsSubtext
      }
    }

    budget {
      isStartEndReading
      isStartEndCalculated
      quantityOnHand
      rate
      unit
    }

    createdDate
    createdBy {
      firstName
      lastName
    }
    updatedDate
    updatedBy {
      firstName
      lastName
    }

    actions
    grants {
      type
      ids
    }
  }
`;

export const GET_ASSET = gql`
  query asset($id: ID!) {
    asset(id: $id) {
      ...BaseAsset
    }
  }
  ${BASE_ASSET}
`;

export const GET_ASSETS = gql`
  query assets($input: AssetsConnectionInput!) {
    assets(input: $input) {
      totalCount
      assets {
        id
        name
        assetType
        schemaId
        colorId
        markerId
        mainPhotoFileId
        attributes
        budget {
          isStartEndReading
          isStartEndCalculated
          quantityOnHand
          rate
          unit
        }
        location {
          coordinates
          type
        }
        createdDate
        createdBy {
          firstName
          lastName
        }
        updatedDate
        updatedBy {
          firstName
          lastName
        }
      }
    }
  }
`;

export const GET_ASSETS_WITH_ELEMENTS = gql`
  query assetsWithElements($input: AssetsWithElementsInput!) {
    assetsWithElements(input: $input) {
      totalCount
      assets {
        id
        name
        assetType
        markerId
        schemaId
        attributes
        attributeGroups {
          id
          name
          expandByDefault
          attributes
        }
        elements
        elementGroups {
          id
          name
          elements
        }
      }
    }
  }
`;

export const SEARCH_ASSETS = gql`
  query assetsSearch($input: SearchAssetsConnectionInput!) {
    assetsSearch(input: $input) {
      totalCount
      assets {
        id
        schemaId
        externalId
        name
        assetType
        markerId
        colorId
        categoryPath
        isMaterial
        inactive
        budget {
          isStockBased
          rate
          unit
        }
      }
    }
  }
`;

export const SEARCH_ASSETS_WITH_ELEMENTS = gql`
  query assetsWithElementsSearch(
    $input: SearchAssetsWithElementsConnectionInput!
  ) {
    assetsWithElementsSearch(input: $input) {
      totalCount
      assets {
        id
        schemaId
        externalId
        name
        assetType
        markerId
        colorId
        categoryPath
        isMaterial
        inactive
        budget {
          isStockBased
          rate
          unit
        }
        isSubItem
        ancestors {
          id
          name
        }
        categories {
          id
          name
        }
        attributes
        attributeGroups {
          id
          name
          expandByDefault
          attributes
        }
      }
    }
  }
`;

export const MOVE_ELEMENT = gql`
  mutation moveElement($input: MoveElementInput!) {
    moveElement(input: $input)
  }
`;

export const REPLACE_ELEMENT = gql`
  mutation replaceElement($input: ReplaceElementInput!) {
    replaceElement(input: $input)
  }
`;

export const CREATE_ASSET = gql`
  mutation assetCreate($input: AssetCreateInput!) {
    assetCreate(input: $input) {
      ...BaseAsset
    }
  }
  ${BASE_ASSET}
`;
